import { MandatorType, useMandatorContext } from "@rentablo/theming";
import i18next from "i18next";
import { useEffect } from "react";

const addTranslation = async (mandatorSlug: MandatorType) => {
  const mandatorResource = await import(
    `../translations/mandators/${mandatorSlug}.ts`
  )
    .then((module) => module.default)
    .catch(() => ({}));

  const deResource = mandatorResource.de ?? mandatorResource;
  const enResource = mandatorResource.en ?? mandatorResource;

  i18next.addResourceBundle("de", "translation", deResource || {}, true, true);
  i18next.addResourceBundle("en", "translation", enResource || {}, true, true);
};

export const useMandatorSpecificTranslations = () => {
  const { mandatorSlug } = useMandatorContext();

  useEffect(() => {
    if (!mandatorSlug) return;
    addTranslation(mandatorSlug);
  }, [mandatorSlug]);
};
